import { Injectable, Injector } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { EventData, EventInteractionService } from '@mare-common/ngx-mare-common';
import { environment } from 'src/environments/environment';
import { TokenService } from './token.service';
import { NavigationService } from './navigation.service';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { PlatformApiWPublicService } from './platform-apiwp-public.service';

@Injectable({
  providedIn: 'root'
})
export class RoutingService {
  


  SelfcaringRoutes: any[] = [
    {
      wpPath: '/opportunity-workflow/',
      path: environment.routingBasePath + '/selfcaring/workflow',
      match: 'startsWith',
      params: [
        {
          urlParam: 'oid',
          routeParam: 'oid'
        },
        {
          urlParam: 'sku',
          routeParam: 'sku'
        }
      ]
    }
  ]

  ProductRoutes: any[] = [
    {
      wpPath: '/product/:sku',
      path: environment.routingBasePath + '/product',
      match: 'startsWith',
      params: [
        {
          urlParam: 'sku',
          routeParam: 'sku'
        }
      ]
    }
  ]

  PlatformSsoRoutes: any[] = [
    {
      wpPath: '/maresso',
      path: environment.routingBasePath + '/maresso',
      match: 'startsWith',
      params: [
        {
          urlParam: 'platform',
          routeParam: 'platform'
        }
      ],
      isExternal: true,
      override: true,
      overrideUrlFn: (params: any) => {
        let url = '';
        if (params && params.platform) {
          switch (params.platform) {
            case 'marker':
              url = 'https://app.markerweb.it/publicaccess?ssoToken=' + this.tokenService.getAccessToken()
              break;
            case 'dmj':
            case 'drivemyjob':
            case 'driveMyJob':
              url = 'https://app.drivemyjob.it/publicaccess?ssoToken=' + this.tokenService.getAccessToken()
              break;
            case 'solveup':
            case 'solveUp':
              url = 'https://app.solveup.it/publicaccess?ssoToken=' + this.tokenService.getAccessToken()
              break;
            case 'obiettivoeuropa':
            case 'obiettivoEuropa':
            case 'oe':
            case 'obiettivo-europa':
              url = 'https://www.obiettivoeuropa.com/sso?access_token=' + this.tokenService.getAccessToken()
              break;
          }

          Object.keys(params).forEach(param => {
            if (param !== 'platform') {
              url += (url.includes('?') ? '&' : '?') + param + '=' + params[param]
            }
          })

        }
        return url
      }
    }
  ]
  platformApiWpService!: PlatformApiWPublicService;
  authService!: MareAuthService;
  savedRedirect: string | null = null;


  constructor(
    private eventInteractionService: EventInteractionService,
    private router: Router,
    private tokenService: TokenService,
    private navigationService: NavigationService,
    // private authService: MareAuthService,
    private injector: Injector
  ) {

    this.eventInteractionService.getObservable().subscribe((event: EventData) => {
      switch (event.event) {
        case 'gotoLink':
          console.log('event.data', event.data)
          this.route(event.data);
          break;
        default:
          break;
      }
    });

    if (this.tokenService.isInit) {
      this.init();
    } else {
      let subscription = this.tokenService.isInit$.subscribe((res) => {
        if (res) {
          subscription.unsubscribe();
          this.init();
        }
      })
    }

  }

  init() {
    // if (!this.authService.isLogged()) {
    //   this.platformApiWpService = this.injector.get(PlatformApiWPublicService);
    // }
  }

  routingNavigate(defaultRedirect: string, checkAlternate: boolean = false) {
    let { requestedUrl, params } = this.getRequestedUrl();
    if (requestedUrl) {
      if (params) {
        requestedUrl += '?';
        params.forEach((param: any) => {
          requestedUrl += `${param.key}=${param.value}&`;
        })
      }
      this.route({ url: requestedUrl });
    } else {
      this.route({ url: defaultRedirect });
    }
  }

  setRequestedUrl(requestedUrl: string, params: any) {
    window.sessionStorage.setItem('requested_url', requestedUrl);
    window.sessionStorage.setItem('requested_url_params', JSON.stringify(params));
  }

  getRequestedUrl() {
    const requestedUrl = window.sessionStorage.getItem('requested_url');
    const params = JSON.parse(window.sessionStorage.getItem('requested_url_params') ?? '{}');
    window.sessionStorage.removeItem('requested_url');
    window.sessionStorage.removeItem('requested_url_params');
    return { requestedUrl, params };
  }

  setup() {

  }
  route(data: any) {
    if (!data || !data.url) {
      return;
    }
    if (data.url.startsWith('http')) {
      window.open(data.url, '_blank');
      return;
    }

    const { url, params, isExternal, override } = this.checkRoute(data.url);
    if (isExternal) {
      if (override) {
        window.open(url, '_blank');
      } else {
        window.open(data.url, '_blank');
      }
      return;
    }
    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };
    this.router.navigate([url], navigationExtras).catch((error) => {
      // console.error('Error routing', error);
      window.open(data.url);
    });

  }
  checkRoute(url: any): { url: any; params?: any; isExternal?: boolean, override?: boolean } {

    let params: any = {};

    let manageMergedRoutes = this.SelfcaringRoutes.concat(this.PlatformSsoRoutes).concat(this.ProductRoutes);
    console.log('checkurl', url, manageMergedRoutes, 'checkurl');
    if (url.indexOf('?') > -1) {
      const decoded = this.decodeUrlAndParams(url);
      url = decoded.url;
      params = decoded.params;
    }
    for (const managedRoute of manageMergedRoutes) {
      if (managedRoute.match === 'startsWith') {
        if (url.startsWith(managedRoute.wpPath)) {
          return this.manageRoute(url, managedRoute, params);

        }
      } else if (managedRoute.match === 'equals') {
        if (url === managedRoute.wpPath) {
          // const params = this.getParams(url, managedRoute);
          // return { url: managedRoute.path, params, isExternal: managedRoute.isExternal };
          return this.manageRoute(url, managedRoute, params);
        }
      }

    }



    // for (let index = 0; index < this.SelfcaringRoutes.length; index++) {
    //   const route = this.SelfcaringRoutes[index];
    //   if(route.match === 'startsWith') {
    //     if(url.startsWith(route.wpPath)) {
    //       const params = this.getParams(url, route);
    //       return { url: route.path, params };
    //     }
    //   } else if(route.match === 'equals') {
    //     if(url === route.wpPath) {
    //       const params = this.getParams(url, route);
    //       return { url: route.path, params };
    //     }
    //   }
    // }
    return { url, params };

  }

  private manageRoute(url: any, managedRoute: any, params?: any): { url: any; params?: any; isExternal?: boolean, override?: boolean } {
    if (!params) {
      params = this.getParams(url, managedRoute);
    }
    let retUrl = managedRoute.path;
    if (managedRoute.override && managedRoute.overrideUrlFn) {
      retUrl = managedRoute.overrideUrlFn(params);
    }
    return { url: retUrl, params, isExternal: managedRoute.isExternal, override: managedRoute.override };
  }

  getParams(url: any, route: any) {
    let params: any = {};
    const urlParams: any = this.getUrlParams(url);
    route.params.forEach((param: any) => {
      const urlParam: any = urlParams[param.urlParam];
      if (urlParam) {
        params[param.routeParam] = urlParam;
      }
    });
    return params;
  }
  getUrlParams(url: any) {
    let params: any = {};
    if (url.indexOf('?') > -1) {
      const paramsString = url.split('?')[1];
      paramsString.split('&').forEach((param: any) => {
        const [key, value] = param.split('=');
        params[key] = value;
      });
    }
    return params;
  }

  decodeUrlAndParams(url: any) {
    if (url.indexOf('?') > -1) {
      const splitted = url.split('?');
      url = splitted[0];
      let params: any = {};
      splitted[1].split('&').forEach((param: any) => {
        const [key, value] = param.split('=');
        params[key] = value;
      });
      return { url, params };
    }
    return { url };
  }

  checkForHash(): string | null {
    const hash = this.router.url.split('#')[1];
    if (hash) {
      return hash;
    } else {
      return null;
    }
  }

  navigate( commands: any[], extras?: NavigationExtras) {
    if(!this.authService) {
      this.authService = this.injector.get(MareAuthService);
      if(!this.authService.isLogged()) {
        this.platformApiWpService = this.injector.get(PlatformApiWPublicService);
      }
    }
    if(this.platformApiWpService) {
      if(!extras) {
        extras = {};
      }
      if(!extras.queryParams) {
        extras.queryParams = {};
      }
      extras.queryParams['token'] = this.platformApiWpService.getToken();
    }
    this.router.navigate(commands, extras);
  }

  registerRedirect(redirect_uri: string | null) {
      this.savedRedirect = redirect_uri;
      if(this.savedRedirect)
        localStorage.setItem('savedRedirect', this.savedRedirect);
      else
        localStorage.removeItem('savedRedirect');
  }

  getRedirect() {
    this.savedRedirect = localStorage.getItem('savedRedirect');
    return this.savedRedirect;
  }

}
